import tippy from 'tippy.js';

export default class Tooltip {
  static init(elements) {
    tippy(elements, {
      allowHTML: true,
      content: (reference) => reference.querySelector('.aui-tooltip__content') || reference.getAttribute('data-aui-tooltip') || reference.getAttribute('title'),
    });
  }
}